var generic = generic || {};
var site = site || {};

site.offer = site.offer || {};
site.offer.ui = site.offer.ui || {};
site.sop = site.sop || {};

site.Sop = function (context) {
  this.init(context);
};

site.Sop.prototype = {
  $el: $(), // sop
  $selection: $(),
  offercode: '',
  offerData: {},
  transData: 0,
  eventCount: 0,
  skus: '',
  multiSkuView: 0,
  productData: {},
  selectedSku: '',
  appliedSku: '',
  soldOutSkus: 0,
  soldOut: 0,
  $loader: $(),
  $template: $(),
  $button: $(),
  $selection: $(),
  $checkboxes: $(),
  $overlay: $(),
  $anchor: $(),
  checkInventory: function (productData) {
    var self = this;
    var skus = productData.skus;

    $(skus).each(function (index, sku) {
      if (this.INVENTORY_STATUS === 7) {
        this['inventory'] = 0;
        self.soldOutSkus++;
      } else {
        this['inventory'] = 1;
      }
    });
    if (self.soldOutSkus === skus.length) {
      self.soldOut = 1;
    }
    self.multiSkuView = skus.length === 1 ? 0 : 1;
    self.renderView(productData);
  },
  renderView: function (productData) {
    var self = this;

    self.productData = productData;
    if (self.multiSkuView) {
      self.$template = $('script.inline-template[path="offer_selection"]').html();
      self.$selection = Mustache.render(self.$template, self.productData);
      // console.log('-- sku data --');
      // console.log(self.productData.skus);
      $('.js-product-full__offer__selections', self.$el).append(self.$selection);
    }
    self.$el.addClass('offer__loaded');
    self.checkCart();
  },
  checkCart: function () {
    var self = this;

    // is item alredy in cart?
    if (self.transData) {
      $.each(self.transData.order.samples, function (index, sample) {
        if (sample.OFFER_CODE === self.offercode) {
          self.appliedSku = sample['sku.SKU_ID'];
          // console.log('-- cart sku --');
          // console.log(self.appliedSku);
        }
      });
    }
    self.getDom();
  },
  getDom: function () {
    var self = this;

    self.$loader = $('.js-product-full__loader', self.$el);
    self.$button = $('.js-product-full__add-button', self.$el);
    self.$selection = $('.js-product-full__offer', self.$el);
    self.$checkboxes = $('.js-offer__selections__checkbox', self.$selection);
    self.$overlay = $('.js-product-full__offer__success', self.$selection).html();
    self.addEvents();
  },
  addEvents: function () {
    var self = this;

    // setup
    if (self.appliedSku.length) {
      self.appliedState(1);
      self.selectedSku = self.appliedSku;
    } else {
      self.$loader.addClass('hidden');
      if (self.soldOut) {
        self.$button.addClass('offer__soldout');

        return;
      }
      $.each(self.productData.skus, function (index, el) {
        if (this['inventory'] != 0) {
          self.selectedSku = this.SKU_ID;

          return false;
        }
      });
    }
    self.$button.attr('data-sku-id', self.selectedSku);

    if (self.multiSkuView) {
      $('.js-offer__selections__checkbox[data-sku-id="' + self.selectedSku + '"]', self.$selection).prop('checked', true);
      // one checkbox at a time
      self.$checkboxes.on('change', function (event) {
        if (this.checked) {
          self.$checkboxes.not(this).prop('checked', false);
          self.selectedSku = $(this).data('sku-id');
          // update image
          try {
            var skuData = _.find(self.productData.skus, function (sku) {
              return sku.SKU_ID == self.selectedSku;
            });
            var skuImage = skuData.XL_IMAGE[0];

            $('.product-full__image-main img').attr('src', skuImage);
          } catch (e) {
            // error: just use the main image
          }

          self.$button.attr('data-sku-id', self.selectedSku);
          if (self.selectedSku == self.appliedSku) {
            self.appliedState(1);
          } else {
            self.appliedState(0);
          }
        }
      });
    }

    // add offer
    self.$button.on('click', function (event) {
      event.preventDefault();
      var skuId = $(this).data('sku-id');

      site.offer.ui.applyOffer(self.offercode, skuId);
      // add loading class
      self.$loader.removeClass('hidden');
    });
  },
  appliedState: function (state) {
    var self = this;

    if (state) {
      self.$loader.addClass('hidden');
      self.$button.addClass('offer__applied');
      if (self.selectedSku.length) {
        self.appliedSku = self.selectedSku;
      }
    } else {
      self.$button.removeClass('offer__applied');
    }
  },
  successOverlay: function () {
    var self = this;

    generic.overlay.launch({
      content: self.$overlay,
      includeBackground: true,
      cssStyle: {
        width: '500px',
        height: '200px'
      }
    });
  },
  listeners: function () {
    var self = this;
    var offerLoaded = 'offerData:' + self.offercode + ':loaded';
    var dualLoaded = offerLoaded + ' transData:loaded';

    // listen for loaded data
    $(document).on(dualLoaded, function (event, data) {
      if (event.type === offerLoaded) {
        // console.log(event.type);
        self.offerData = data;
        self.eventCount++;
      } else if (event.type === 'transData:loaded') {
        // console.log('transData:loaded');
        self.transData = data;
        self.eventCount++;
      }
      if (self.eventCount === 2) {
        // console.log('all data loaded');
        $.each(self.offerData.benefits, function (idx, benefit) {
          if (benefit.choices) {
            self.skus = benefit.choices;
          }
        });
        site.offer.ui.getProductData(self.skus, self.offercode);
      }
    });

    $(document).on('skus:' + self.offercode + ':loaded', function (event, productData) {
      // console.log(event.type);
      self.checkInventory(productData);
    });

    $(document).on('offer:' + self.offercode + ':applied', function (event, response) {
      // console.log(event.type);
      self.appliedState(1);
      self.successOverlay();
    });
  },
  headerHeight: function () {
    // similar to Drupal.ELB.ui.header_height();
    // avoiding global change due to impact
    var toolbarHeight = $('#toolbar').height();
    var pageHeaderHeight = $('.page-header').outerHeight();

    if ($('#toolbar').hasClass('mobile')) {
      var searchHeight = $('.el-mobile-search-block').outerHeight();

      // toolbar always has height on mobile
      // subtract search bar in case sticky header is in play
      return pageHeaderHeight - searchHeight;
    } else {
      return toolbarHeight + pageHeaderHeight;
    }
  },
  startSlider: function (context) {
    var $altImage = $('.js-product-full-images', context);

    if ($altImage.length > 0) {
      $altImage.slick({
        dots: true,
        customPaging: function (slider, i) {
          var thumb = $(slider.$slides[i]).find('img').attr('src');

          return '<div class="js-product-image-thumb product-full__image__thumb" style="background-image: url(' + thumb + ')"></div>';
        },
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        onAfterChange: function (args) {
          if (Drupal.settings.analytics.analytics_integrated) {
            $(document).trigger('SLICKCHANGE', args.$slides.get(args.currentSlide));
          }
        },
        responsive: [
          {
            breakpoint: 768,
            settings: {
              customPaging: function(i) {
                return '<button type="button">' + (i + 1) + '</button>';
              }
            }
          }
        ]
      });
    }
  },
  init: function (context) {
    var self = this;

    self.$el = $(context);
    self.offercode = self.$el.data('offercode');
    self.listeners();
    self.offerData = site.offer.ui.getOfferData(self.offercode);
    self.transData = site.offer.ui.getTransData();
    self.startSlider(self.$el);

    // setup prior to offer loading
    // details link
    var headerOffset = site.client.isMobile ? 25 : 50;

    self.$anchor = $('.js-product-full__detail-link', context);
    self.$anchor.click(function (event) {
      event.preventDefault();
      var headerOffset = self.headerHeight();

      $.scrollTo($('.spp-product__details').offset().top - headerOffset, 400);
    });
  }
};

// single offer page
(function ($) {
  Drupal.behaviors.sop_v1 = {
    attach: function (context, settings) {
      var $container = $('.js-sop--v1', context);

      $container.each(function (index, el) {
        var sop = new site.Sop(this);
      });
    }
  };
})(jQuery);
